<template>
  <v-layout justify-center class="white">
    <v-flex xs12 sm10 md10 justify-center>
      <v-layout>
        <v-flex xm12 sm4 class="title text-xs-center text-sm-left align-center">
        </v-flex>
        <v-flex xm12 md4 class="text-sm-center">
          <span class="headline">Permits/Licenses</span><br />
        </v-flex>
      </v-layout>

      <v-card>
        <v-card-text>
          <vue-good-table
            ref="my-table"
            styleClass="vgt-table striped bordered"
            :max-height=this.height
            :fixed-header="true"
            :isLoading=this.isTableLoading
            :columns="columns"
            :rows="rows"
            @on-row-click="onRowClick"
            :search-options="{
              enabled: true
            }">
            <template slot="loadingContent">
              <div>
                <v-progress-circular
                  :size="50"
                  :width="7"
                  color="blue"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
            <div slot="table-actions-bottom">
              <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
            </div>
            <template slot="table-row" slot-scope="props">
              <span>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
          </vue-good-table>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-flex xs12 class="text-xs-center text-sm-center">
                    <span class="headline">{{ editedItem.name }}</span><br />
                    <span class="subheading">Booth(s): {{ editedItem.title }}</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn
                      v-if="editedItem.email"
                      block
                      color="blue-grey"
                      class="white--text"
                      :href="sendEmail"
                    >
                      Email {{editedItem.fullName}}
                      <v-icon right dark>email</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="editedItem.cellPhone"
                      block
                      color="blue-grey"
                      class="white--text"
                      :href="callMobile"
                    >
                      Call Primary - {{editedItem.pname}}
                      <v-icon right dark>mobile_screen_share</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="editedItem.homePhone"
                      block
                      color="blue-grey"
                      class="white--text"
                      :href="callHome"
                    >
                      Call Pri Onsite - {{editedItem.poname}}
                      <v-icon right dark>mobile_screen_share</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="editedItem.workPhone"
                      block
                      color="blue-grey"
                      class="white--text"
                      :href="callWork"
                    >
                      Call Sec Onsite - {{editedItem.soname}}
                      <v-icon right dark>mobile_screen_share</v-icon>
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'

export default {
  props: ['item'],

  components: {
    VueGoodTable
  },

  data () {
    return {
      myId: this.$store.state.user.id,
      myName: this.$store.state.user.fullName,
      page: 'permits',
      currentYear: 0,
      dialog: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      height: 0,
      columns: [
        {
          label: 'Type',
          field: 'type',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Number/License',
          field: 'permitNumber',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Note',
          field: 'note',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        }
      ],
      rows: [],
      editedItem: {}
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getPermits()
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  methods: {
    handleResize () {
      const height = window.innerHeight - 600
      this.height = height + 'px'
    },

    async getPermits () {
      try {
        const response = await Api().get('vendor_permits/' + this.currentYear)

        const vendorList = response.data
        console.log('vendorList', vendorList)

        for (let i in vendorList) {
          let booths = ''
          for (let j in vendorList[i].VendorCompany.VendorBooths) {
            booths = booths + vendorList[i].VendorCompany.VendorBooths[j].boothNumber + ' '
          }
          vendorList[i].VendorCompany.booths = booths
        }

        this.rows = vendorList

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async onRowClick (params) {
      try {
        console.log('props', params.row)
        console.log('co', params.row.VendorCompany)
        this.editedItem.id = params.row.VendorCompany.id
        this.editedItem.name = params.row.VendorCompany.name
        this.editedItem.title = params.row.VendorCompany.booths

        const response = await Api().get('vendor_contact/' + params.row.VendorCompany.VendorDetails[0].primaryContact)
        const contact = response.data
        if (contact) {
          this.editedItem.pname = contact.firstName
          this.editedItem.cellPhone = contact.mobile
          this.callMobile = 'tel:' + contact.mobile
        }

        const response1 = await Api().get('vendor_contact/' + params.row.VendorCompany.VendorDetails[0].primaryOnsite)
        const contact1 = response1.data
        if (contact1) {
          this.editedItem.poname = contact.firstName
          this.editedItem.homePhone = contact1.mobile
          this.homePhone = 'tel:' + contact1.mobile
        }

        const response2 = await Api().get('vendor_contact/' + params.row.VendorCompany.VendorDetails[0].secondaryOnsite)
        const contact2 = response2.data
        if (contact2) {
          this.editedItem.soname = contact.firstName
          this.editedItem.workPhone = contact2.mobile
          this.workPhone = 'tel:' + contact2.mobile
        }

        this.dialog = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    close () {
      this.dialog = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/vendor/PermitList.vue